import { logEvent } from 'firebase/analytics';
import { analytics } from '../components/firebase';

// Simple, consistent analytics wrapper:
// - ensures params are strings/numbers (Firebase Analytics requirement)
// - never throws (analytics should not break UX)
// - supports "pending navigation context" so section views can include source surface

let pendingNavigationContext = null;

const normalizeParams = (params) => {
  const out = {};
  if (!params || typeof params !== 'object') return out;

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (typeof value === 'boolean') {
      out[key] = value ? 1 : 0;
      return;
    }
    if (typeof value === 'number') {
      out[key] = value;
      return;
    }
    out[key] = String(value);
  });

  return out;
};

export const track = (eventName, params) => {
  try {
    logEvent(analytics, eventName, normalizeParams(params));
  } catch (_) {
    // Swallow analytics failures; UX must still work.
  }
};

// For hash-based navigation we log the actual "section_view" when the section state
// updates, but we still want to know what UI surface caused it (nav, command bar, etc).
export const setPendingNavContext = (context) => {
  pendingNavigationContext = context ? { ...context, _ts: Date.now() } : null;
};

export const consumePendingNavContext = () => {
  const ctx = pendingNavigationContext;
  pendingNavigationContext = null;
  return ctx;
};

